import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";

import qs from "qs"
/**
 * 公司
 */
const company = {

  /**
   * 创建
   * @param {*} name 公司名称,不能为空字符串
   * @param {*} shortName 公司名称简称,不能为空字符串
   * @param {*} address 公司地址
   * @param {*} addressDetail 详细地址
   * @param {*} addressGisX 公司地址GIS x
   * @param {*} addressGisY 公司地址GIS y
   * @param {*} contactPerson 联系人
   * @param {*} contactPhoneNumber 联系电话,可以是座机或手机
   * @param {*} contactEmail 联系邮箱
   * @param {*} parentId 父公司id
   * @param {*} adminRoleName 初始管理员角色名称
   * @param {*} loginPassword 操作用户登录密码
   * @returns 
   */
  createCompany (name, shortName, address, addressDetail, addressGisX, addressGisY, contactPerson, contactPhoneNumber, contactEmail, parentId, adminRoleName, loginPassword) {
    return axios.post(base.company.createCompany, utils.postParamsArrayToJsonString({ name, shortName, address, addressDetail, addressGisX, addressGisY, contactPerson, contactPhoneNumber, contactEmail, parentId, adminRoleName, loginPassword }))
  },
  /**
   * 修改
   * @param {*} companyId 需要修改的公司id,0表示本公司
   * @param {*} name 公司名称,不能为空字符串
   * @param {*} shortName 公司名称简称,不能为空字符串
   * @param {*} address 公司地址
   * @param {*} addressDetail 详细地址
   * @param {*} addressGisX 公司地址GIS x
   * @param {*} addressGisY 公司地址GIS y
   * @param {*} contactPerson 联系人
   * @param {*} contactPhoneNumber 联系电话,可以是座机或手机
   * @param {*} contactEmail 联系邮箱
   * @returns 
   */
  modifyCompany (companyId, name, shortName, address, addressDetail, addressGisX, addressGisY, contactPerson, contactPhoneNumber, contactEmail, loginPassword) {
    return axios.post(base.company.modifyCompany, utils.postParamsArrayToJsonString({ companyId, name, shortName, address, addressDetail, addressGisX, addressGisY, contactPerson, contactPhoneNumber, contactEmail, loginPassword }))
  },
  /**
   * 查询公司信息
   * @param {*} companyId 需要查询的公司id
   * @returns 
   */
  getCompanyInfo (companyId) {
    return axios.post(base.company.getCompanyInfo, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 查询子公司信息
   * @param {*} companyId 需要查询的公司id
   * @param {*} onlyDirect 0仅查询直接子公司,1查询旗下所有子公司
   * @returns 
   */
  getSubcompaniesInfo (companyId, onlyDirect) {
    return axios.post(base.company.getSubcompaniesInfo, utils.postParamsArrayToJsonString({ companyId, onlyDirect }))
  },
  /**
   * 查询公司logo
   */
  getCompanyLogo (companyId) {
    return axios.post(base.company.getCompanyLogo, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 设置公司logo
   */
  setCompanyLogo (companyId, logoData) {
    return axios.post(base.company.setCompanyLogo, utils.postParamsArrayToJsonString({ companyId, logoData }))
  },
  /**
   * 快速初始化公司
   */
  quickInitializeCompany (name, shortName, address, addressDetail, addressGisX, addressGisY, contactPerson, contactPhoneNumber, contactEmail, parentId, adminRoleName, menuConfig, loginPassword) {
    return axios.post(base.company.quickInitializeCompany, utils.postParamsArrayToJsonString({ name, shortName, address, addressDetail, addressGisX, addressGisY, contactPerson, contactPhoneNumber, contactEmail, parentId, adminRoleName, menuConfig, loginPassword }))
  },

}

export default company